import {
  fetchCompanyDetails,
  sendTransportRegistrationRequest
} from '@/services/ma-franchise'

export const loadCompanyDetails = async ({ commit }) => {
  const data = await fetchCompanyDetails()
  commit('setCompanyDetails', data)
}

export const submitTransportRegistration = async ({ commit }, transport) => {
  commit('setSendingTransportState', true)
  try {
    await sendTransportRegistrationRequest(transport)
  } finally {
    commit('setSendingTransportState', false)
  }
}
